import { useEffect } from 'react'
import { useLocalStorage } from 'react-use'

const LOCAL_STORAGE_KEY = 'rememberedUsername'

export const useRememberMe = ({ onRemberedUsername }) => {
  const [rememberedUsername, setRememberedUsername] = useLocalStorage<
    string | null | boolean | undefined
  >(LOCAL_STORAGE_KEY, false)

  useEffect(() => {
    if (rememberedUsername) {
      onRemberedUsername(rememberedUsername)
    }
  }, [])

  return { rememberedUsername, setRememberedUsername }
}
